import { ButtonIcon, ButtonSize, ButtonVariant, Dropdown, IconVariants } from "@next-platform/client-common-spicy-ui";
import { useCallback, useState } from "react";

import { ModalSelectModel } from "@/pages/Chat/components/ModalSelectModel";
import AvailableModelSelection from "@/pages/Chat/components/ModelSelectionDropdown/AvailableModelSelection";
import ModelSelectionOverview from "@/pages/Chat/components/ModelSelectionDropdown/ModelSelectionOverview";
import PresetSelectionView from "@/pages/Chat/components/ModelSelectionDropdown/PresetSelectionView";
import { ChatPageModal } from "@/pages/Chat/components/types";

type ViewType = "overview" | "allModels" | "presets";

const ModelSelectionDropdown = ({
  handleModalVisibility,
  dataTestId = "",
}: {
  handleModalVisibility: (modal: ChatPageModal, isOpen: boolean) => void;
  dataTestId?: string;
}) => {
  const [stateIsOpen, setStateIsOpen] = useState(false);
  const [stateCurrentView, setStateCurrentView] = useState<ViewType>("overview");
  const [stateIsModelSelectOpen, setStateIsModelSelectOpen] = useState(false);

  const toggleModelView = () => {
    setStateCurrentView(stateCurrentView === "allModels" ? "overview" : "allModels");
  };

  const togglePresetView = () => {
    setStateCurrentView(stateCurrentView === "presets" ? "overview" : "presets");
  };

  const onOpenChange = useCallback((open: boolean) => {
    setStateIsOpen(open);
    setStateCurrentView("overview");
  }, []);

  const handleClose = useCallback(() => {
    setStateIsOpen(false);
  }, []);

  const handleOpen = useCallback(() => {
    setStateIsOpen(true);
  }, []);

  const renderContent = () => {
    switch (stateCurrentView) {
      case "allModels":
        return <AvailableModelSelection toggleView={toggleModelView} closeDropdown={setStateIsOpen} />;
      case "presets":
        return <PresetSelectionView toggleView={togglePresetView} closeDropdown={setStateIsOpen} />;
      default:
        return (
          <ModelSelectionOverview
            toggleView={toggleModelView}
            togglePresetView={togglePresetView}
            closeDropdown={setStateIsOpen}
            handleModalVisibility={handleModalVisibility}
            setIsModelSelectOpen={setStateIsModelSelectOpen}
          />
        );
    }
  };

  return (
    <div data-testid={dataTestId}>
      {stateIsOpen ? <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40 pointer-events-auto" onClick={handleClose} /> : null}
      <Dropdown isOpen={stateIsOpen} content={renderContent()} placement="bottom-end" onOpenChange={onOpenChange}>
        <ButtonIcon icon={IconVariants.SPARKLES} onClick={handleOpen} variant={ButtonVariant.OUTLINED} size={ButtonSize.MEDIUM} />
      </Dropdown>
      <ModalSelectModel isOpen={stateIsModelSelectOpen} setIsOpen={setStateIsModelSelectOpen} />
    </div>
  );
};

export default ModelSelectionDropdown;
